<div class="container">
  <div class="modal-header">
    <div class="device-header">
      <span>
        <i class="mdi mdi-file-document-edit-outline file-icon"></i>
        <span class="header">View/Edit device</span>
      </span>
      <i class="mdi mdi-close close-icon" mat-dialog-close></i>
    </div>
  </div>

  <form novalidate #deviceForm="ngForm">
    <div class="setup">
      <div class="section-container">
        <div class="section-data">
          <div class="name-field">
            <div class="label"><b>Name *</b></div>
            <input
              matInput
              autocomplete="off"
              type="text"
              name="name"
              class="width100"
              [(ngModel)]="name"
              #nameInput="ngModel"
              (ngModelChange)="nameUpdated()"
              required
            />
            <div class="error" *ngIf="nameExist">
              <mat-error>Name already exist</mat-error>
            </div>
            <div class="error" *ngIf="nameInput.invalid && (nameInput.dirty || nameInput.touched)">
              <mat-error *ngIf="nameInput?.errors?.required"> Required</mat-error>
              <mat-error *ngIf="nameInput.errors.regex && !nameInput.errors.required"
                >Name should not contain '?,%,/' special characters</mat-error
              >
            </div>
          </div>
          <div class="site-field" *ngIf="isSiteCacheAvailable">
            <div class="label"><b>Site</b></div>
            <viavi-common-dropdown
              [dropDownData]="siteDropDown"
              [configuration]="dropdownConfiguration"
              (valueChange)="siteSelection($event)"
              [defaultSelection]="selectedSite"
              *ngIf="siteDropDown && siteDropDown.length > 0 && dropdownConfiguration"
              [isCustomDropdown]="true"
            ></viavi-common-dropdown>
          </div>
          <div class="location-fields" *ngIf="!isSiteCacheAvailable">
            <div class="label"><b>Location</b></div>
            <input
              matInput
              autocomplete="off"
              type="text"
              name="location"
              [(ngModel)]="location"
              class="width100"
            />
          </div>
          <div class="latitude-fields" *ngIf="!isSiteCacheAvailable">
            <div class="latitude-field">
              <div class="label"><b>Latitude</b></div>
              <input
                matInput
                autocomplete="off"
                type="text"
                name="latitude"
                #latitudeInput="ngModel"
                [(ngModel)]="latitude"
                [pattern]="latitudeIPRegex"
                class="width40"
              />
              <div
                class="error"
                *ngIf="latitudeInput.invalid && (latitudeInput.dirty || latitudeInput.touched)"
              >
                <mat-error *ngIf="latitudeInput.errors?.pattern">Invalid Latitude value</mat-error>
              </div>
            </div>
            <div class="longitude-field">
              <div class="label"><b>Longitude</b></div>
              <input
                matInput
                autocomplete="off"
                type="text"
                name="longitude"
                #longitudeInput="ngModel"
                [(ngModel)]="longitude"
                [pattern]="longitudeIPRegex"
                class="width40"
              />
              <div
                class="error"
                *ngIf="longitudeInput.invalid && (longitudeInput.dirty || longitudeInput.touched)"
              >
                <mat-error *ngIf="longitudeInput.errors?.pattern"
                  >Invalid Longitude value</mat-error
                >
              </div>
            </div>
          </div>
        </div>
        <div class="vendor-section-data">
          <div class="vendor-field-data">
            <div class="label"><b>Vendor</b></div>
            <input
              matInput
              autocomplete="off"
              type="text"
              name="vendor"
              class="width100"
              [(ngModel)]="vendor"
              #vendorInput="ngModel"
            />
          </div>
          <div class="vendor-field-data">
            <div class="label"><b>Model</b></div>
            <input
              matInput
              autocomplete="off"
              type="text"
              name="model"
              class="width100"
              [(ngModel)]="model"
              #modelInput="ngModel"
            />
          </div>
          <div class="vendor-field-data">
            <div class="label"><b>Version</b></div>
            <input
              matInput
              autocomplete="off"
              type="text"
              name="version"
              class="width100"
              [(ngModel)]="version"
              #versionInput="ngModel"
            />
          </div>
        </div>
      </div>
      <div class="devider"></div>
      <mat-tab-group
        [selectedIndex]="selectedTabIndex"
        (selectedTabChange)="onTabChange($event)"
        class="users-tab-group"
      >
        <mat-tab label="Reflectors">
          <div class="tab-content">
            <div class="section-container">
              <div class="type-section-label width40 twampFullLabel">
                <mat-checkbox
                  (change)="onChecked('twampFull', $event)"
                  [checked]="isTwampFullChecked"
                  color="primary"
                  ><b class="reflector-label">TWAMP Full</b></mat-checkbox
                >
              </div>
              <div
                class="type-section-data width40"
                [ngClass]="isTwampFullChecked ? 'enabled-inputs' : 'disabled-inputs'"
              >
                <div class="label"><b>Control server IP address *</b></div>
                <input
                  matInput
                  autocomplete="off"
                  type="text"
                  name="twampFullIpAddress"
                  class="width100"
                  [(ngModel)]="twampFullIpAddress"
                  #twampFullIpAddressInput="ngModel"
                  [pattern]="validIPRegex"
                  [disabled]="!isTwampFullChecked"
                  (ngModelChange)="validateInput('twampFullIpAddress', $event)"
                  required
                />
                <div class="error" *ngIf="twampFullIpError">
                  <mat-error>IP already used</mat-error>
                </div>
                <div
                  class="error"
                  *ngIf="
                    twampFullIpAddressInput.invalid &&
                    (twampFullIpAddressInput.dirty || twampFullIpAddressInput.touched)
                  "
                >
                  <mat-error *ngIf="twampFullIpAddressInput.errors?.pattern"
                    >Invalid IP address</mat-error
                  >
                  <mat-error *ngIf="twampFullIpAddressInput?.errors?.required">Required</mat-error>
                </div>
              </div>
              <div
                class="type-section-data width20 margin-r-0"
                [ngClass]="isTwampFullChecked ? 'enabled-inputs' : 'disabled-inputs'"
              >
                <div class="label"><b>Control server port *</b></div>
                <input
                  matInput
                  autocomplete="off"
                  type="number"
                  name="twampFullport"
                  class="width100"
                  [(ngModel)]="twampFullport"
                  #twampFullPortInput="ngModel"
                  min="1"
                  max="65535"
                  [pattern]="wholeNumberReg"
                  [disabled]="!isTwampFullChecked"
                  required
                />
                <div
                  class="error"
                  *ngIf="
                    twampFullPortInput.invalid &&
                    (twampFullPortInput.dirty || twampFullPortInput.touched)
                  "
                >
                  <mat-error
                    *ngIf="twampFullPortInput.errors?.min || twampFullPortInput.errors?.max"
                  >
                    Valid values 1-65535</mat-error
                  >
                  <mat-error *ngIf="twampFullPortInput.errors?.pattern">Invalid port</mat-error>
                  <mat-error *ngIf="twampFullPortInput?.errors?.required">Required</mat-error>
                </div>
              </div>
            </div>

            <div class="section-container">
              <div class="type-section-label width40">
                <mat-checkbox
                  (change)="onChecked('twampLight', $event)"
                  [checked]="isTwampLightChecked"
                  color="primary"
                  ><b class="reflector-label">TWAMP Light</b></mat-checkbox
                >
              </div>
              <div
                class="type-section-data width40"
                [ngClass]="isTwampLightChecked ? 'enabled-inputs' : 'disabled-inputs'"
              >
                <div class="label"><b>IP address *</b></div>
                <input
                  matInput
                  autocomplete="off"
                  type="text"
                  name="twampLightIpAddress"
                  class="width100"
                  [(ngModel)]="twampLightIpAddress"
                  #twampLightIpAddressInput="ngModel"
                  [pattern]="validIPRegex"
                  [disabled]="!isTwampLightChecked"
                  (ngModelChange)="validateInput('twampLightIpAddress', $event)"
                  required
                />
                <div class="error" *ngIf="twampLightIpError">
                  <mat-error>IP already used</mat-error>
                </div>
                <div
                  class="error"
                  *ngIf="
                    twampLightIpAddressInput.invalid &&
                    (twampLightIpAddressInput.dirty || twampLightIpAddressInput.touched)
                  "
                >
                  <mat-error *ngIf="twampLightIpAddressInput.errors?.pattern"
                    >Invalid IP address</mat-error
                  >
                  <mat-error *ngIf="twampLightIpAddressInput?.errors?.required">Required</mat-error>
                </div>
              </div>
              <div
                class="type-section-data width20 margin-r-0"
                [ngClass]="isTwampLightChecked ? 'enabled-inputs' : 'disabled-inputs'"
              >
                <div class="label"><b>UDP port *</b></div>
                <input
                  matInput
                  autocomplete="off"
                  type="number"
                  name="twampLightport"
                  class="width100"
                  [(ngModel)]="twampLightport"
                  #twampLightPortInput="ngModel"
                  min="1"
                  max="65535"
                  [pattern]="wholeNumberReg"
                  [disabled]="!isTwampLightChecked"
                  required
                />
                <div
                  class="error"
                  *ngIf="
                    twampLightPortInput.invalid &&
                    (twampLightPortInput.dirty || twampLightPortInput.touched)
                  "
                >
                  <mat-error
                    *ngIf="twampLightPortInput.errors?.min || twampLightPortInput.errors?.max"
                  >
                    Valid values 1-65535</mat-error
                  >
                  <mat-error *ngIf="twampLightPortInput.errors?.pattern">Invalid port</mat-error>
                  <mat-error *ngIf="twampLightPortInput?.errors?.required">Required</mat-error>
                </div>
              </div>
            </div>
            <div class="section-container">
              <div class="type-section-label width40">
                <mat-checkbox
                  (change)="onChecked('ping', $event)"
                  [checked]="isPingChecked"
                  color="primary"
                  ><b class="reflector-label">Ping Reflector</b></mat-checkbox
                >
              </div>
              <div
                class="type-section-data width40"
                [ngClass]="isPingChecked ? 'enabled-inputs' : 'disabled-inputs'"
              >
                <div class="label"><b>IP address *</b></div>
                <input
                  matInput
                  autocomplete="off"
                  type="text"
                  name="pingIpAddress"
                  class="width100"
                  [(ngModel)]="pingIpAddress"
                  #pingIpAddressInput="ngModel"
                  [pattern]="validIPRegex"
                  [disabled]="!isPingChecked"
                  (ngModelChange)="validateInput('pingIpAddress', $event)"
                  required
                />
                <div class="error" *ngIf="pingIpError">
                  <mat-error>IP already used</mat-error>
                </div>
                <div
                  class="error"
                  *ngIf="
                    pingIpAddressInput.invalid &&
                    (pingIpAddressInput.dirty || pingIpAddressInput.touched)
                  "
                >
                  <mat-error *ngIf="pingIpAddressInput.errors?.pattern"
                    >Invalid IP address</mat-error
                  >
                  <mat-error *ngIf="pingIpAddressInput?.errors?.required">Required</mat-error>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Loopbacks" *ngIf="showLoopbackDevicesTab">
          <div class="tab-content">
            <div class="section-container">
              <div class="type-section-label width40">
                <mat-checkbox
                  (change)="onCheckLoopbackOption('L2Loopback', $event)"
                  [checked]="isL2LoopbackChecked"
                  color="primary"
                >
                  <b class="reflector-label">L2 Loopback</b>
                </mat-checkbox>
              </div>
              <div
                class="type-section-data width40"
                [ngClass]="isL2LoopbackChecked ? 'enabled-inputs' : 'disabled-inputs'"
              >
                <div class="label"><b>MAC address *</b></div>
                <input
                  matInput
                  autocomplete="off"
                  type="text"
                  name="l2LoopbackMacAddress"
                  class="width100"
                  [(ngModel)]="l2LoopbackMacAddress"
                  #l2LoopbackMacAddressInput="ngModel"
                  [pattern]="validMacRegex"
                  [disabled]="!isL2LoopbackChecked"
                  (ngModelChange)="validateInput('mac', $event)"
                  required
                />
                <div class="error" *ngIf="macAddressCheck">
                  <mat-error>Mac already exist</mat-error>
                </div>
                <div
                  class="error"
                  *ngIf="
                    l2LoopbackMacAddressInput.invalid &&
                    (l2LoopbackMacAddressInput.dirty || l2LoopbackMacAddressInput.touched)
                  "
                >
                  <mat-error *ngIf="l2LoopbackMacAddressInput.errors?.pattern"
                    >Invalid MAC address</mat-error
                  >
                  <mat-error *ngIf="l2LoopbackMacAddressInput?.errors?.required"
                    >Required</mat-error
                  >
                </div>
              </div>
            </div>
            <div class="section-container">
              <div class="type-section-label width40">
                <mat-checkbox
                  (change)="onCheckLoopbackOption('L3Ipv4Loopback', $event)"
                  [checked]="isL3Ipv4LoopbackChecked"
                  color="primary"
                >
                  <b class="reflector-label">L3 IPV4 Loopback</b>
                </mat-checkbox>
              </div>
              <div
                class="type-section-data width40"
                [ngClass]="isL3Ipv4LoopbackChecked ? 'enabled-inputs' : 'disabled-inputs'"
              >
                <div class="label"><b>IP address *</b></div>
                <input
                  matInput
                  autocomplete="off"
                  type="text"
                  name="l3Ipv4LoopbackIpAddress"
                  class="width100"
                  [(ngModel)]="l3Ipv4LoopbackIpAddress"
                  #l3Ipv4LoopbackIpAddressInput="ngModel"
                  [pattern]="validIPV4Regex"
                  [disabled]="!isL3Ipv4LoopbackChecked"
                  (ngModelChange)="validateInput('l3Ipv4LoopbackIpAddress', $event)"
                  required
                />
                <div class="error" *ngIf="l3Ipv4LoopbackIpError">
                  <mat-error>IP already used</mat-error>
                </div>
                <div
                  class="error"
                  *ngIf="
                    l3Ipv4LoopbackIpAddressInput.invalid &&
                    (l3Ipv4LoopbackIpAddressInput.dirty || l3Ipv4LoopbackIpAddressInput.touched)
                  "
                >
                  <mat-error *ngIf="l3Ipv4LoopbackIpAddressInput.errors?.pattern"
                    >Invalid IPV4 address</mat-error
                  >
                  <mat-error *ngIf="l3Ipv4LoopbackIpAddressInput?.errors?.required"
                    >Required</mat-error
                  >
                </div>
              </div>
            </div>
            <div class="section-container">
              <div class="type-section-label width40">
                <mat-checkbox
                  (change)="onCheckLoopbackOption('L3Ipv6Loopback', $event)"
                  [checked]="isL3Ipv6LoopbackChecked"
                  color="primary"
                >
                  <b class="reflector-label">L3 IPV6 Loopback</b>
                </mat-checkbox>
              </div>
              <div
                class="type-section-data width40"
                [ngClass]="isL3Ipv6LoopbackChecked ? 'enabled-inputs' : 'disabled-inputs'"
              >
                <div class="label"><b>IP address *</b></div>
                <input
                  matInput
                  autocomplete="off"
                  type="text"
                  name="l3Ipv6LoopbackIpAddress"
                  class="width100"
                  [(ngModel)]="l3Ipv6LoopbackIpAddress"
                  #l3Ipv6LoopbackIpAddressInput="ngModel"
                  [pattern]="validIPV6Regex"
                  [disabled]="!isL3Ipv6LoopbackChecked"
                  (ngModelChange)="validateInput('l3Ipv6LoopbackIpAddress', $event)"
                  required
                />
                <div class="error" *ngIf="l3Ipv6LoopbackIpError">
                  <mat-error>IP already used</mat-error>
                </div>
                <div
                  class="error"
                  *ngIf="
                    l3Ipv6LoopbackIpAddressInput.invalid &&
                    (l3Ipv6LoopbackIpAddressInput.dirty || l3Ipv6LoopbackIpAddressInput.touched)
                  "
                >
                  <mat-error *ngIf="l3Ipv6LoopbackIpAddressInput.errors?.pattern"
                    >Invalid IPV6 address</mat-error
                  >
                  <mat-error *ngIf="l3Ipv6LoopbackIpAddressInput?.errors?.required"
                    >Required</mat-error
                  >
                </div>
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </form>
  <div class="btn-group add-device">
    <button
      mat-flat-button
      class="save-btn"
      [disabled]="!form.valid || saveBtnDisabled()"
      (click)="saveDevice()"
    >
      SAVE
    </button>
    <button mat-button class="save-btn cancel" mat-dialog-close>CANCEL</button>
  </div>
</div>
<progress-spinner *ngIf="isLoading"></progress-spinner>
